import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EodDistributorRoutingModule } from './eod-distributor-routing.module';
import { EodDistributorComponent } from './eod-distributor.component';
import { TopNavComponent } from "./sub-component/top-nav/top-nav.component";
import {CalendarModule} from "primeng/calendar";
import {AppPrimengModule} from "../../app.primeng.module";
import {SharedModule} from "../../shared.module";
import {SideNavComponent} from "./sub-component/side-nav/side-nav.component";
import { FundDayEndReportComponent } from './sub-component/fund-day-end-report/fund-day-end-report.component';
import { FdeReportTableComponent } from './sub-component/fund-day-end-report/fde-report-table/fde-report-table.component';
import { NewSecurityComponent } from './sub-component/new-security/new-security.component';
import { NewSecurityTableComponent } from './sub-component/new-security/new-security-table/new-security-table.component';
import { FdeNavReportComponent } from './sub-component/fund-day-end-report/fde-nav-report/fde-nav-report.component';
import { BbgNavTableComponent } from './sub-component/fund-day-end-report/fde-nav-report/bbg-nav-table/bbg-nav-table.component';
import { CrNavTableComponent } from './sub-component/fund-day-end-report/fde-nav-report/cr-nav-table/cr-nav-table.component';
import { MsNavTableComponent } from './sub-component/fund-day-end-report/fde-nav-report/ms-nav-table/ms-nav-table.component';
import { BbgHoldingTableComponent } from './sub-component/fund-day-end-report/fde-holding/bbg-holding-table/bbg-holding-table.component';
import { NewSecurityDetailComponent } from './sub-component/new-security/new-security-detail/new-security-detail.component';
import {ConfirmationPopupModule} from "../../menu-popups/confirmation-popup/confirmation-popup.module";


@NgModule({
  declarations: [
    EodDistributorComponent,
    TopNavComponent,
    SideNavComponent,
    FundDayEndReportComponent,
    FdeReportTableComponent,
    NewSecurityComponent,
    NewSecurityTableComponent,
    FdeNavReportComponent,
    BbgNavTableComponent,
    CrNavTableComponent,
    MsNavTableComponent,
    BbgHoldingTableComponent,
    NewSecurityDetailComponent,
  ],
  imports: [
    CommonModule,
    EodDistributorRoutingModule,
    CalendarModule,
    AppPrimengModule,
    SharedModule,
    ConfirmationPopupModule
  ],
  exports: [
    EodDistributorComponent
  ]
})
export class EodDistributorModule { }


